<template>
  <div v-if="!hidePage">
    <h1>Audience Matters Automatic Login Page</h1>
    <div>
      if you see this page, please contact the Audience Matters Developer team.
      
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      hidePage: true
    }
  },
  beforeCreate () {
    this.$auth.signInWithRedirect()
    setTimeout(() => {
      this.hidePage = false
    }, 3000)
  }
}

</script>

<style lang='scss'>


</style>



// WEBPACK FOOTER //
// OKTALoginPage.vue?0edcf8e4